import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Coming Soon Gate Component
 *
 * Full-screen landing page that blocks access to the app.
 * Controlled by the `coming_soon_enabled` system feature flag in admin settings.
 *
 * Unlock methods (bypass the gate even when enabled):
 *   1. Browser console: localStorage.setItem('nibni_internal_access', 'vnext2026')
 *   2. URL parameter:   ?access=vnext2026
 *
 * The gate logic lives in ComingSoonService (core/services/coming-soon.service.ts).
 * AppComponent subscribes to it and renders this component when the flag is on.
 */
@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="coming-soon-gate">
      <div class="coming-soon-content">
        <img src="assets/images/brand/logo/nibni-logo-white.png" alt="nibni" class="coming-soon-logo" />
        <p class="coming-soon-text">Coming Soon</p>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: fixed;
      inset: 0;
      z-index: 99999;
    }

    .coming-soon-gate {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0a0a0a;
    }

    .coming-soon-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }

    .coming-soon-logo {
      width: 180px;
      height: auto;
      opacity: 0.95;
    }

    .coming-soon-text {
      font-family: 'Inter', system-ui, -apple-system, sans-serif;
      font-size: 1.25rem;
      font-weight: 300;
      letter-spacing: 0.35em;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.5);
      margin: 0;
    }
  `]
})
export class ComingSoonComponent {}
